import ePaymentMode from "../enums/ePaymentMode"

export function paymentModeFormatter(mode: ePaymentMode): string {
  switch (mode) {
    case ePaymentMode.MODE_OFFLINE:
      return "Offline"
    case ePaymentMode.MODE_BOOKER:
      return "Booker"
    case ePaymentMode.MODE_POS:
      return "POS"
    case ePaymentMode.MODE_POS_TERMINAL:
      return "POS Terminal"
    case ePaymentMode.MODE_PAYMENT_LINK:
      return "Payment Link"
    case ePaymentMode.MODE_MANUAL_UPDATE:
      return "Manual Update"
    case ePaymentMode.MODE_INVOICE:
      return "Invoice"
    default:
      return "Unknown"
  }
}
